<template>
  <div @touchmove="preLoad(getPre)" class="facing_index">
    <classify :category-list="indexCategoryList" :type="3"></classify>

    <swiper
      dots-position="center"
      :auto="true"
      style="height: 4rem !important;"
    >
      <swiper-item
        class="swiper-demo-img"
        v-for="(item, index) in bannerList"
        :key="item.id"
        @click.native="bannerClick(item)"
      >
        <img :src="item.picUrl" />
      </swiper-item>
    </swiper>
    <!-- <div class="nav_box" >
      <div class="nav_div cl" ref="nav_div">
        <div class="nav_item" ref="nav_item" v-for="item in navList" @click="navClick(item)"><span>{{item.name}}</span></div>
      </div>
    </div> -->
    <special-com :special-list="specialList"></special-com>

    <ul class="hasPadding">
      <li
        v-for="(item, index) in courseList"
        @click="jump(item)"
        class="vux-1px-b"
      >
        <div class="smail">
          <img class="left" :src="item.picUrl" alt="" />
          <div>
            <h5>{{ item.name }}</h5>
            <p>{{ item.introduce }}</p>
          </div>
        </div>
      </li>
    </ul>
    <p style="text-align:center;margin-top: 1rem" v-show="!courseList.length">
      <inline-loading></inline-loading>
      <span style="vertical-align:middle;display:inline-block;font-size:14px;">
        &nbsp;&nbsp;加载中
      </span>
    </p>
  </div>
</template>
<script>
import SpecialCom from '@/page/FacingEachOther/components/special.vue';
import Classify from '@/components/Classify.vue';
import { mapState } from 'vuex';
import { facing } from '@/api/ajax.js';
import { loadMore } from '@/Mixin/loadMore.js';
// TODO: vux
import { Swiper, SwiperItem } from 'vux';
export default {
  name: 'facing_index',
  mixins: [loadMore],
  data() {
    return {
      courseList: [],
      bannerList: [],
      navList: [],
      params: {
        pageNo: 1,
        pageSize: 20
      },
      page: {
        pageNo: 1,
        pageSize: 3
      },
      loadFlag: true,
      indexCategoryList: [],
      specialList: []
    };
  },
  methods: {
    jump(item) {
      if (item.skipType == 1) {
        this.$router.push({
          name: 'courseDetail',
          params: { id: item.skipId }
        });
      } else {
        this.$router.push({
          name: 'headlineDetail',
          params: { id: item.skipId },
          query: { type: 0 }
        });
      }
    },
    getBannerAndNav() {
      facing.bannerList().then(res => {
        this.bannerList = res.data.data;
      });
      facing.specialList(this.page).then(res => {
        this.specialList = res.data.data.list;
      });
    },

    bannerClick(item) {
      if (item.skipType == 1) {
        //跳转类型 0 无 1 专题 2访问 3 报道
        this.$router.push({ name: 'special', params: { id: item.skipId } });
      } else if (item.skipType == 3) {
        this.$router.push({
          name: 'headlineDetail',
          params: { id: item.skipId },
          query: { type: 0 }
        });
      } else {
        this.$router.push({
          name: 'courseDetail',
          params: { id: item.skipId }
        });
      }
    },
    navClick(item) {
      this.$router.push({ name: 'special', params: { id: item.id } });
    },
    info() {
      //初始化滑动
      this.courseList = [];
      this.params.pageNo = 1;
      this.loadFlag = true;
    },
    getList(data) {
      if (this.loadFlag) {
        this.loadFlag = false;
        facing.list(data).then(res => {
          for (var i = 0; i < res.data.data.list.length; i++) {
            this.courseList.push(res.data.data.list[i]);
          }
          if (res.data.data.list.length < 20) {
            this.loadFlag = false;
            return false;
          }
          this.params.pageNo += 1;
          this.loadFlag = true;
        });
      }
    },
    getPre() {
      this.getList(
        Object.assign(this.params, {
          categoryId: this.classifyId.id
        })
      );
    },
    indexCategory() {
      facing.category().then(res => {
        if (res.data.data[2].categoryName == '神经') {
          res.data.data.splice(2, 1);
        }
        this.indexCategoryList = res.data.data;
      });
    }
  },
  computed: {
    ...mapState({
      classifyId: state => state.classifyId
    })
  },
  watch: {
    //classifyId 触发 改变内容
    classifyId(val) {
      this.info();
      this.getList(
        Object.assign(this.params, {
          categoryId: val.id
        })
      );
    }
  },
  components: {
    Classify,
    Swiper,
    SwiperItem,
    SpecialCom
  },
  created() {
    this.indexCategory();
    this.getPre();
    this.getBannerAndNav();
  }
};
</script>
<style lang="less">
.facing_index {
  .vux-indicator-center {
    bottom: 0.2rem !important;
  }
  .vux-icon-dot {
    background: rgba(255, 255, 255, 0.4);
  }
  .active {
    width: 0.2933rem !important;
    height: 0.133rem !important;
    background-color: #027cfa !important;
    /*border-radius: 7.5px 5px 7.5px 7.5px !important;*/
  }
}
</style>
<style lang="less" scoped>
.swiper-demo-img {
  img {
    max-width: 100%;
    /*height:4rem;*/
  }
}
</style>
<style lang="less" scoped>
ul {
  padding: 0.1rem 0.4rem;
  li {
    padding-top: 0.267rem;
    padding-bottom: 0.267rem;
  }
}

.big {
  img {
    width: 100%;
    height: 3.6rem;
  }
}

.smail {
  display: flex;
  justify-content: space-between;
  img {
    width: 2.42rem;
    height: 2.42rem;
  }
  div {
    width: 6.5rem;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
  }
  h5 {
    font-size: 0.3733rem;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    min-height: 1rem;
  }
  p {
    margin-top: 0.1rem;
    line-height: 1.3;
    font-size: 0.332rem;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }
}
.nav_box {
  overflow-x: scroll;
  overflow-y: hidden;
}
.nav_div {
  padding: 0 0.4rem;
  margin-top: 0.2666rem;
  .nav_item {
    padding: 0.1733rem 0.3733rem;
    border: 1px solid #027cfa;
    border-radius: 1.33rem;
    color: #027cfa;
    font-size: 0.4rem;
    float: left;
    margin-right: 0.2133rem;
  }
}
</style>
